import { Fragment, useState, useEffect } from 'react'
import {
  bookEnterpriseMeeting,
  canUserSubscribeToProduct,
  getMonthlyRateCurrPrice,
} from '../../utils/Helper'
import instance from '../../utils/Axios'
import { toast } from 'react-toastify'
import { PaymentConstants } from '../../constants/Payments'
import { ProductCodes } from '../../constants'

const PLANS = [
  // {
  //   title: 'Free',
  //   code: 'free',
  //   subtitle: 'For newly minted creatives, or those on a small budget',
  //   priceYearly: 'Free',
  //   priceMonthly: 'Free',
  //   cummPrice: '',
  //   brief2: '+15-30% per licensing transaction',
  //   featuresTitle: 'Core features include',
  //   features: [
  //     '10 assets/month',
  //     'Bolt-on for large asset volume',
  //     'Licensing templates',
  //     'Provenance labelling',
  //     'Double encryption',
  //     //  'Creative Commons',
  //     'Visible watermarking',
  //     'Legally compliant e-signature',
  //     'Direct royalty payment',
  //     'License now',
  //   ],
  // },
  {
    title: 'Solo Creator',
    code: 'solo-creator',
    subtitle:
      'For individuals serious about licensing revenue and provenance labelling',
    priceYearly: '£4.50',
    priceMonthly: '£7.00',
    cummPrice: '£54',
    brief2: '+2% per licensing transaction if applicable',
    featuresTitle: 'Core features include',
    features: [
      '15 assets/month',
      'Bolt-on for large asset volume',
      'Licensing templates',
      'Provenance labelling',
      'Double encryption',
      'Creative Commons',
      'Visible watermarking',
      'Legally compliant e-signature',
      'Direct royalty payment',
      'License now',
    ],
  },
  {
    title: 'Business',
    code: 'business',
    subtitle:
      'Ideal for small teams requiring custom branding, licensing, internal policy implementation, and provenance labelling for large volumes of assets',
    priceYearly: '£20',
    priceMonthly: '£30',
    cummPrice: '£240',
    brief2: '+2% per licensing transaction if applicable',
    featuresTitle: 'Core features include',
    features: [
      '15 assets/month/user',
      'Bolt-on for large asset volume',
      'No-code custom license/policy builder',
      'Licensing templates',
      'Provenance labelling',
      'Double encryption',
      'Creative Commons',
      'Visible watermarking',
      'Legally compliant e-signature',
      'Direct royalty payment',
      'License now',
      'Customised branding',
      'Legal/agreement admin',
      'Bulk agreements',
    ],
  },
  {
    title: 'Business Pro',
    code: 'business-pro',
    subtitle:
      'Professional organisations requiring custom branding, licensing, internal policy implementation, and provenance labelling for large volumes of assets',
    priceYearly: '£41.50',
    priceMonthly: '£60',
    cummPrice: '£498',
    brief2: '',
    featuresTitle: 'Core features include',
    features: [
      '20 assets/month/user',
      'Bolt-on for large asset volume',
      'No-code custom license/policy builder',
      'Licensing templates',
      'Provenance labelling',
      'Double encryption',
      'Creative Commons',
      'Visible watermarking',
      'Legally compliant e-signature',
      'Direct royalty payment',
      'License now',
      'Customised branding',
      'Legal/agreement admin',
      'Bulk agreements',
      'No licensing fee',
    ],
    popular: true,
  },
  {
    title: 'Enterprise',
    code: 'enterprise',
    subtitle:
      'Large organisations requiring custom branding, licensing, internal policy implementation, and provenance labelling for large volumes of assets, Plus customer support.',
    priceYearly: 'Custom Pricing',
    priceMonthly: '.',
    cummPrice: '. Contact us to discuss your requirements.',
    brief2: '',
    featuresTitle: 'Core features include',
    features: [
      '50 assets/month/user',
      'Bolt-on for large asset volume',
      'No-code custom license/policy builder',
      'Licensing templates',
      'Provenance labelling',
      'Double encryption',
      'Creative Commons',
      'Visible watermarking',
      'Legally compliant e-signature',
      'Direct royalty payment',
      'License now',
      'Customised branding',
      'Legal/agreement admin',
      'Bulk agreements',
      'No licensing fee',
      'API access',
      '24/7 support',
      'Single sign-on (SSO)',
      'Service level agreement',
      'Custom integration available',
    ],
  },
]

const PricingPlan = ({
  code,
  title,
  subtitle,
  price,
  cummPrice,
  brief2,
  featuresTitle,
  features,
  popular = false,
  changeActiveProduct,
  pageOn,
  stripePrice,
  stripePriceKey,
  canSubscribe,
  pkg,
  disableIndividualPlans,
}) => {
  const [loading, setLoading] = useState(false)
  const paySubscription = async (code) => {
    if (code === 'enterprise') {
      return bookEnterpriseMeeting()
    }
    setLoading(true)
    try {
      const response = await instance.post('/subscriptions/pay', {
        stripePrice,
        stripePriceKey,
        package: pkg,
      })

      window.location.href = response.data.url
    } catch (err) {
      toast.error('Cannot get payment link')
    } finally {
      setLoading(false)
    }
  }

  const toggleActiveProduct = (code) => {
    if (code === 'enterprise') {
      return bookEnterpriseMeeting()
    }
    if (changeActiveProduct) {
      changeActiveProduct(code)
    }
  }

  return (
    <div className={`pricing-plan${popular ? ' popular' : ''}`}>
      <div className="pricing-plan__top">
        {popular && <h4 className="pricing-plan__highlight">MOST POPULAR</h4>}
        <h3 className="pricing-plan__title">{title}</h3>
        <p className="pricing-plan__subtitle">{subtitle}</p>
        {price === 'Free' ? (
          <h4 className="pricing-plan__price">{price}</h4>
        ) : price ? (
          <h4 className="pricing-plan__price">
            {title === 'Enterprise' ? (
              'Contact Us'
            ) : (
              <>
                {price}/
                <span className="pricing-plan__price-sub">month per user</span>
              </>
            )}
          </h4>
        ) : null}
        <p className="pricing-plan__price-brief1">
          {cummPrice ? `${cummPrice} billed annually` : ''}
        </p>
        <p className="pricing-plan__price-brief2">{brief2}</p>
      </div>
      {pageOn === 'subscribe' ? (
        <button
          disabled={loading || !canSubscribe}
          className="pricing-plan__buy-btn"
          onClick={() => {
            paySubscription(code)
          }}>
          {code === 'enterprise' ? 'Talk to us' : 'Subscribe'}
        </button>
      ) : (
        <button
          className="pricing-plan__buy-btn"
          disabled={!price || disableIndividualPlans}
          onClick={() => toggleActiveProduct(code)}>
          {code === 'enterprise' ? 'Talk to us' : 'Start Now'}
        </button>
      )}
      <p className="pricing-plan__details-title">{featuresTitle}</p>
      <ul className="pricing-plan__details">
        {features.map((feature) => (
          <li>
            <b>&#10003;</b> <span>{feature}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

const ProductsFeatures = ({
  products,
  pricingDurationActive,
  changeActiveProduct,
  show,
  pageOn,
  subscriptionData,
}) => {
  const [clientName, setClientName] = useState()

  useEffect(() => {
    // Get user session storage
    const newUser = sessionStorage.getItem('newUser')
    if (newUser) {
      const user = JSON.parse(newUser)
      setClientName(user?.clientName)
    }
  }, [])

  return (
    <div className="plans" style={{ display: show ? 'flex' : 'none' }}>
      {PLANS.map((plan, index) => {
        const product = products?.find((product) => product.code === plan.code)
        const price =
          pricingDurationActive === 1
            ? (product && getMonthlyRateCurrPrice(product?.priceAnnually)) ||
              plan.priceYearly
            : plan.priceMonthly
        const cummPrice =
          pricingDurationActive === 1
            ? product?.priceAnnually || plan.cummPrice
            : null
        const stripePriceKey = PaymentConstants.getStripePriceKey(
          pricingDurationActive,
        )
        const pkg = PaymentConstants.getProductPeriodPackage(
          pricingDurationActive,
        )
        const stripePrice = product?.[stripePriceKey]
        const propsObj = {
          ...plan,
          price,
          cummPrice,
          stripePrice,
          stripePriceKey,
          pkg,
        }
        const canSubscribe = canUserSubscribeToProduct(
          subscriptionData?.subscriptionProduct,
          product,
          subscriptionData?.isTrialPlan,
          subscriptionData?.activeSubscription,
        )
        // Disable individual plan for client sign ups
        const disableIndividualPlans =
          clientName &&
          [ProductCodes.SoloCreator, ProductCodes.Free].includes(plan.code)
        return (
          <Fragment key={index}>
            <PricingPlan
              {...propsObj}
              key={index}
              changeActiveProduct={changeActiveProduct}
              pageOn={pageOn}
              canSubscribe={canSubscribe}
              disableIndividualPlans={disableIndividualPlans}
            />
          </Fragment>
        )
      })}
    </div>
  )
}

export default ProductsFeatures
